// Stimulus replaces the React components this app still mounts. It is loaded
// through webpack rather than importmap because importmap needs propshaft or
// sprockets: sprockets is gone, and propshaft is what react-rails 2.4.7 breaks
// on. Importmap can only arrive once React does not.
import { Application } from '@hotwired/stimulus';

const application = Application.start();
application.debug = false;

const context = require.context('.', true, /_controller\.js$/);
context.keys().forEach(key => {
  const identifier = key
    .replace(/^\.\//, '')
    .replace(/_controller\.js$/, '')
    .replace(/\//g, '--')
    .replace(/_/g, '-');
  application.register(identifier, context(key).default);
});

export { application };
